<section id="wrapper">
    <div class="login-register" style="background-image:url(assets/images/background/login-register.jpg);">
        <div class="row justify-content-center">
            <h4 class="text-white">Estimado, gracias por elegirnos. </h4>
        </div>
        <div class="row justify-content-center">
            <h4 class="text-white">Por favor, para continuar con la compra, ingrese los siguientes datos:</h4>
        </div>
        <div class="login-box card">
            <div class="card-body">
                <form [formGroup]="registerForm" class="form-horizontal form-material" id="loginform" (ngSubmit)="register()">
                    <div class="row justify-content-center">                        
                      <h3 *ngIf="!(domainService.logoUrl$ | async)" class="box-title m-b-20"><img src="assets/images/favicon.png" width="50"/>Registro </h3>
                      <img *ngIf="(domainService.logoUrl$ | async)" width="180" [src]="domainService.logoUrl$ | async"/>
                      <div class="col-12">
                        <h3 *ngIf="(domainService.logoUrl$ | async)" class="box-title text-center m-b-20">Registro </h3>                    
                      </div>
                    </div>
                    <div class="form-group ">
                        <div class="col-xs-12">
                            <input formControlName="email" autocapitalize="off" autocorrect="off" class="form-control" id="not-copy" type="text"  placeholder="Email">
                        </div>
                    </div>
                    <div class="form-group ">
                        <div class="col-xs-12">
                            <input formControlName="confEmail" class="form-control not-paste" id="not-paste" type="text"  placeholder="Confirmar email">
                        </div>
                    </div>
                    <div class="form-group ">
                        <div class="col-xs-12">
                            <input formControlName="password" autocapitalize="off" autocorrect="off" class="form-control" type="password"  placeholder="Contraseña">
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-xs-12">
                            <input formControlName="confPassword" autocapitalize="off" autocorrect="off" class="form-control" type="password"  placeholder="Confirmar contraseña">
                        </div>
                    </div>

                    <div class="form-group text-center p-b-20">
                        <div class="col-xs-12">
                            <button [disabled]="!registerForm.valid" [ngStyle]="{backgroundColor : (domainService.customColor$ | async)}" class="btn btn-info btn-lg btn-block btn-rounded text-uppercase waves-effect waves-light" type="submit">Regístrate</button>
                        </div>
                        <div *ngIf="campoNoValido('email')" class="text-danger">Revise su email</div>
                        <div *ngIf="campoNoValido('password')" class="text-danger">Revise contraseñas</div>
                    </div>
                    <div class="form-group m-b-0">
                        <div class="col-sm-12 text-center">
                            Ya tienes una cuenta? <a [routerLink]="['/login']" class="text-info m-l-5"><b [ngStyle]="{color : (domainService.customColor$ | async)}">Ingresa</b></a>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</section>